// @module NVT.AssociateMembershipForm.AssoMembForm
define('NVT.AssociateMembershipForm.AssoMembForm.View'
	,	[
			'nvt_associatemembershipform_assomembform.tpl'
		
		,	'NVT.AssociateMembershipForm.AssoMembForm.SS2Model'
	
		,	'NVT.AssociateMembershipForm.ReviewSubmission.View'

		,	'NVT.AssociateMembershipForm.GlobalformAddress.View'
		
		, 	'Backbone'
	
		, 	'Backbone.FormView'
	
		, 	'GlobalViews.Message.View'
	
		, 	'GlobalViews.Confirmation.View'
	
		, 	'underscore'
	
		, 	'jQuery'
	
		, 	'Utils'
	
		]
	, function (
		nvt_associatemembershipform_assomembform_tpl
		
		,	AssoMembFormSS2Model
	
		,	ReviewSubmissionView

		,	GlobalformAddressView
		
		,	Backbone
		
		, 	BackboneFormView
	
		, 	MessageView
	
		, 	GlobalViewsConfirmationView
	
		,	_
	
		, 	jQuery
	
		, 	Utils
	
	)
	{
		'use strict';
	
		// @class NVT.AssociateMembershipForm.AssoMembForm.View @extends Backbone.View
		return Backbone.View.extend({
	
			template: nvt_associatemembershipform_assomembform_tpl
	
		,	initialize: function (options) {
	
				this.application = options.application;
				this.parentView = options.parentView;
				this.model = new AssoMembFormSS2Model();
					BackboneFormView.add(this);		
				this.title = Utils.translate("Associate Membership Application Form");

				var self = this;
				self.globaladdresslist = [];
				self.IsValidatedUennumber = [];
				self.uen_number_saturated_or_non_saturated = true;
				self.associate_provide_details = false;
				self.associate_provide_details_another = false;
				self.associate_provide_details_review_submited = false;
				self.associate_provide_details_review_showed = '';
				self.continueDataFlow = {};
			}
	
		,	title: Utils.translate("Associate Membership Application Form")

		,	page_header: Utils.translate("Associate Membership Application Form")
	
		,	events: {
	
				'click [data-action="reset_form_option"]': 'reset_form_option',

				'keyup #uen': 'IsValidatedUen',
		
				'click [data-action="next_step_process"]': 'nextStepProcess',
	
				'click [data-action="next_step_process_back_1"]': 'nextStepProcessBack_1',
				
				'click [data-action="next_step_process_1"]': 'nextStepProcessbtn',
	
				'click [data-action="next_step_process_back"]': 'nextStepProcessBack',
	
				'click [data-action="next_step_process_second"]': 'nextStepProcessSecond',
	
				'click [data-action="next_step_process_second_back"]': 'nextStepProcessSecondBack',
	
				'click [data-action="next_step_process_third"]': 'nextStepProcessThird',
	
				'click [data-action="next_step_process_third_back"]': 'nextStepProcessThirdBack',
	
				'submit form': 'saveTheForm',
	
				// 'click [data-action="same_for_main"]': 'CopySameMainAddressToMain',
	
				'click [data-action="same_for_billing"]': 'CopySameMainAddressToBilling',
	
				'click button[data-action="next_step_review_submission"]': 'isReviewsubmission',

				'click [data-action="option_referred_by_member"]': 'OptionReferredByMember',	

				'keyup #postal_code': 'pincodeapicsall',

				'keyup #itraisaba_postal_code': 'BillingAddresspincodeapicsall',

				'click [data-action="data-action-ihraisaba"]': 'dataActionIhraisaba',

				'click a[data-action="dynemic-Address-Call"]': 'dynemicAddressCall',

				'click button[data-action="dynemic-Address-Calls"]': 'dynemicAddressCallUpdate',

				'click button[data-action="dynemic-Address-Calls-Remove"]': 'dynemicAddressCallsRemove',

				// 'click [data-action="option_welcome_kit"]': 'OptionWelcomeKit',	

				'change [data-action="getsseventother"]': 'getIsEventOther',
			}
	
		,	bindings: {
	        	
			}
	
		, 	childViews: {
	
			}

		,	reset_form_option : function(e)
			{
				var self = this;

				if(e.currentTarget.value == 'Yes'){               
					self.IsValidatedUen(e);
				}
				else{

				}
			}			

		, 	getIsEventOther: function (e) {

			e.preventDefault();
			var self = this;
			self.continueDataFlow.howdidiyoujknowsbf = jQuery("#howdidiyoujknowsbf").val();
			self.continueDataFlow.is_details_event_other = false;
			self.continueDataFlow.details_event_other = '';
			self.continueDataFlow.details_event_other_label = '';
			if(self.continueDataFlow.howdidiyoujknowsbf =='3')
			{
				self.continueDataFlow.details_event_other_label = 'Please let us know the name of the event attended'
				self.continueDataFlow.is_details_event_other = true
			}

			if(self.continueDataFlow.howdidiyoujknowsbf =='4')
			{
				self.continueDataFlow.details_event_other_label ='Please let us know how you came to know about SBF'
				self.continueDataFlow.is_details_event_other = true
			}

			if(self.continueDataFlow.howdidiyoujknowsbf =='5')
			{
				self.continueDataFlow.details_event_other_label ='Please let us know which social media platform (e.g LinkedIn, Facebook, etc.)'
				self.continueDataFlow.is_details_event_other = true
			}
			

			self.continueDataFlow.getbusinesssector = ""; //jQuery("#getbusinesssector").val();
			self.continueDataFlow.getbusinesssector_text = ""; //jQuery("#getbusinesssector option:selected").text();
			self.continueDataFlow.nature_of_business = jQuery("#nature_of_business").val();
			self.continueDataFlow.annual_turnover = jQuery("#annual_turnover").val();
			self.continueDataFlow.fixed_assets_investments = jQuery("#fixed_assets_investments").val();
			self.continueDataFlow.total_employees = jQuery("#total_employees").val();
			self.continueDataFlow.reason_for_joining = jQuery("#reason_for_joining").val();
			self.continueDataFlow.howdidiyoujknowsbf = jQuery("#howdidiyoujknowsbf").val();
			self.continueDataFlow.details_event_other = jQuery("#details_event_other").val();
			self.continueDataFlow.howdidiyoujknowsbf_text = jQuery("#howdidiyoujknowsbf option:selected").text();
			self.continueDataFlow.option_referred_by_member_yes_No = $('input[name="option_referred_by_member"]:checked').val();
			self.continueDataFlow.referral_name = jQuery("#referral_name").val();
			self.continueDataFlow.referral_department = jQuery("#referral_department").val();
			self.continueDataFlow.referral_company = jQuery("#referral_company").val();
			self.continueDataFlow.Interestineventcollaborationandpartnershipppportunities = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val();
			self.continueDataFlow.ievent_coll_part_oppr = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val() == 'on' ? true : false;

			var aoi_chk_arr =  jQuery('input[name="areas_of_interest[]"]:checked');
			var aoi_chklength = aoi_chk_arr.length;             
			var aoi_array = []
			for(var aoi=0; aoi < aoi_chklength;aoi++)
				{
					aoi_array.push(aoi_chk_arr[aoi].value)
				} 
			self.continueDataFlow.areas_of_interest = aoi_array;

			self.render();
		}

		,	dataActionIhraisaba: function(e)
			{
				e.preventDefault();
				var self = this;
				var getcurrentvalue = jQuery('input[name="if_the_registered_address_is_same_as_billing_address"]:checked').val();
					//self.continueDataFlow.hd_business_profile = jQuery("#hd_business_profile").val();
					self.assinguploadfilevalue();
					self.continueDataFlow.street = jQuery("#street").val();
					self.continueDataFlow.postal_code =  jQuery("#postal_code").val();
					self.continueDataFlow.getcountry = jQuery("#getcountry").val();
					self.continueDataFlow.email = jQuery("#email").val();
					self.continueDataFlow.telephone = jQuery("#telephone").val();
					self.continueDataFlow.website = jQuery("#website").val();
					self.continueDataFlow.unit = jQuery("#unit").val();
					self.continueDataFlow.building = jQuery("#building").val();

				if(getcurrentvalue == 'Yes')
				{
					self.continueDataFlow.if_the_registered_address_is_same_as_billing_address = true;					
				
				}
				else{
					self.continueDataFlow.if_the_registered_address_is_same_as_billing_address = false;
				}	

				self.render();
			}
	
		,	formatTelePhone:function (number) {
				var self = this;
				  // US phone number formats
				const usRegex = /^(?:\(\d{3}\) \d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{3}\.\d{3}\.\d{4}|\d{3} \d{3} \d{4}|\d{10})$/;
    
				  // International phone number formats
				const intlRegex = /^\+\d{2}-\d{3}-\d{7}$|^\+\d{2} \d{3} \d{7}$|^\+\d{2}\.\d{3}\.\d{7}$/;
			  
				return usRegex.test(number) || intlRegex.test(number);
			}
		
		,	isValidURL: function isValidURL(str) {

				return /^http(s)?:\/\/(www\.)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/i.test(str);
			}
			  
		,	BillingAddresspincodeapicsall : function(e)
			{
				e.preventDefault();
				var $target = jQuery(e.target);
				var getpincode = $target.val();
				var self = this;
				if(getpincode.length > 5)
				{
					this.models = new AssoMembFormSS2Model();
					this.models.fetch({async: false,data: {
					   'getmethod':'pincodeAPICall',
					   'getpincode': getpincode
					   }}).done(function(result) {
						if(result)
						{
							self.continueDataFlow.itraisaba_street = result.addr1;
							self.continueDataFlow.itraisaba_postal_code = getpincode;
							self.continueDataFlow.itraisaba_unit = result.addr2 ;
							self.continueDataFlow.itraisaba_building = result.addr3;
							self.continueDataFlow.itraisaba_getcountry = jQuery("#itraisaba_getcountry").val();
						}				 
						else{
							self.continueDataFlow.itraisaba_street = '';
							self.continueDataFlow.itraisaba_postal_code = getpincode;
							self.continueDataFlow.itraisaba_getcountry = jQuery("#itraisaba_getcountry").val();
							self.continueDataFlow.itraisaba_unit = '';
							self.continueDataFlow.itraisaba_building = '';
						}

						self.render();

					});				
				}
			}

		,	pincodeapicsall : function(e)
			{
				e.preventDefault();
				var $target = jQuery(e.target);
				var getpincode = $target.val();
				var self = this;
				if(getpincode.length > 5)
				{
					this.models = new AssoMembFormSS2Model();
					this.models.fetch({async: false,data: {
					   'getmethod':'pincodeAPICall',
					   'getpincode': getpincode
					   }}).done(function(result) {
						if(result)
						{
							//self.continueDataFlow.hd_business_profile = jQuery("#hd_business_profile").val();
							self.assinguploadfilevalue();
							self.continueDataFlow.street = result.addr1;
							self.continueDataFlow.postal_code = getpincode;
							self.continueDataFlow.getcountry = jQuery("#getcountry").val();
							self.continueDataFlow.email = jQuery("#email").val();
							self.continueDataFlow.telephone = jQuery("#telephone").val();
							self.continueDataFlow.website = jQuery("#website").val();
							self.continueDataFlow.unit = result.addr2 ;
							self.continueDataFlow.building = result.addr3;
						}				 
						else{
							//self.continueDataFlow.hd_business_profile = jQuery("#hd_business_profile").val();
							self.assinguploadfilevalue();
							self.continueDataFlow.street = '';
							self.continueDataFlow.postal_code = getpincode;
							self.continueDataFlow.getcountry = jQuery("#getcountry").val();
							self.continueDataFlow.email = jQuery("#email").val();
							self.continueDataFlow.telephone = jQuery("#telephone").val();
							self.continueDataFlow.website = jQuery("#website").val();
							self.continueDataFlow.unit = '';
							self.continueDataFlow.building = '';
						}

						self.render();

					});				
				}
			}

		,	OptionReferredByMember: function(e)
			{
				e.preventDefault();
				var self = this;

				var getcurrentvalue = $('input[name="option_referred_by_member"]:checked').val();
					//self.continueDataFlow.getbusinesssector = jQuery("#getbusinesssector").val();
					self.continueDataFlow.nature_of_business = jQuery("#nature_of_business").val();
					self.continueDataFlow.annual_turnover = jQuery("#annual_turnover").val();
					self.continueDataFlow.fixed_assets_investments = jQuery("#fixed_assets_investments").val();
					self.continueDataFlow.total_employees = jQuery("#total_employees").val();
					self.continueDataFlow.reason_for_joining = jQuery("#reason_for_joining").val();
					self.continueDataFlow.howdidiyoujknowsbf = jQuery("#howdidiyoujknowsbf").val();
					self.continueDataFlow.howdidiyoujknowsbf_text = jQuery("#howdidiyoujknowsbf option:selected").text();
					self.continueDataFlow.referral_name = '';
					self.continueDataFlow.referral_department = '';
					self.continueDataFlow.referral_company = '';
					self.continueDataFlow.details_event_other = jQuery("#details_event_other").val() || '';
					self.continueDataFlow.Interestineventcollaborationandpartnershipppportunities = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val();

					var aoi_chk_arr =  jQuery('input[name="areas_of_interest[]"]:checked');
					var aoi_chklength = aoi_chk_arr.length;             
					var aoi_array = []
					for(var aoi=0; aoi < aoi_chklength;aoi++)
						{
							aoi_array.push(aoi_chk_arr[aoi].value)
						} 
					self.continueDataFlow.areas_of_interest = aoi_array;

				if(getcurrentvalue == 'Yes')
				{
					self.continueDataFlow.option_referred_by_member_yes_No = getcurrentvalue;
					self.continueDataFlow.option_referred_by_member_yes = true;
					self.continueDataFlow.option_referred_by_member_no = false;
				}
				else
				{
					self.continueDataFlow.option_referred_by_member_yes_No = getcurrentvalue;
					self.continueDataFlow.option_referred_by_member_yes = false;
					self.continueDataFlow.option_referred_by_member_no = true;
				}
				
				self.render();
			}

		,	OptionWelcomeKit: function(){
				var self = this;
				var getwkval = $('input[name="welcomekit"]:checked').val();
					self.continueDataFlow.submitting_person_option = jQuery("#submitting_person_option").val();
					self.continueDataFlow.designation_option = jQuery("#designation_option").val();
					self.continueDataFlow.business_email_option = jQuery("#business_email_option").val();
				//if(getwkval)
				//{
					self.continueDataFlow.welcomekit_check = 'Yes'; //$('input[name="welcomekit"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcome_kit_name = jQuery("#welcome_kit_name").val();
					self.continueDataFlow.welcome_kit_jobtitle = jQuery("#welcome_kit_jobtitle").val();
					self.continueDataFlow.welcomekit_email = jQuery("#welcome_kit_email").val();
				//}
				// else{
				// 	self.continueDataFlow.welcomekit_check = '';
				// 	self.continueDataFlow.welcome_kit_name = '';
				// 	self.continueDataFlow.welcome_kit_jobtitle = '';
				// 	self.continueDataFlow.welcomekit_email = '';
				// }
				self.render();
			}

		,	CopySameMainAddressToMain: function(e)
			{
				e.preventDefault();
				var self = this;
				var getcurrentvalue = $('input[name="same_for_main"]:checked').val();
	
				self.continueDataFlow.ceo_given_name = jQuery("#ceo_given_name").val();
				self.continueDataFlow.ceo_surname_name = jQuery("#ceo_surname_name").val();
				self.continueDataFlow.ceo_job_title = jQuery("#ceo_job_title").val();
				self.continueDataFlow.ceo_business_email = jQuery("#ceo_business_email").val();
				self.continueDataFlow.ceo_business_telephone = jQuery("#ceo_business_telephone").val();
	
				var getisBillingValue = $('input[name="same_for_billing"]:checked').val();
				if(!getisBillingValue)
				{
					self.continueDataFlow.same_for_billing = '';
					self.continueDataFlow.billing_main_contact_given_name = jQuery("#billing_main_contact_given_name").val();
					self.continueDataFlow.billing_main_contact_surname = jQuery("#billing_main_contact_surname").val();
					self.continueDataFlow.billing_main_contact_job_title = jQuery("#billing_main_contact_job_title").val();
					self.continueDataFlow.billing_main_contact_business_email = jQuery("#billing_main_contact_business_email").val();
					self.continueDataFlow.billing_main_contact_business_telephone = jQuery("#billing_main_contact_business_telephone").val();
				}
				
				if(getcurrentvalue == '1')
				{
					self.continueDataFlow.same_for_main = 'Yes';
					self.continueDataFlow.main_contact_given_name = '';
					self.continueDataFlow.main_contact_surname = '';
					self.continueDataFlow.main_contact_job_title = '';
					self.continueDataFlow.main_contact_business_email = '';
					self.continueDataFlow.main_contact_business_telephone = '';
				}
				else{
					self.continueDataFlow.same_for_main = '';
					self.continueDataFlow.main_contact_given_name = '';
					self.continueDataFlow.main_contact_surname = '';
					self.continueDataFlow.main_contact_job_title = '';
					self.continueDataFlow.main_contact_business_email = '';
					self.continueDataFlow.main_contact_business_telephone = '';
				}
				self.render();
			}
	
		,	CopySameMainAddressToBilling: function(e)
			{
				e.preventDefault();
				var self = this;
				var getcurrentvalue = jQuery('input[name="same_for_billing"]:checked').val();;
	
				self.continueDataFlow.ceo_given_name = jQuery("#ceo_given_name").val();
				self.continueDataFlow.ceo_surname_name = jQuery("#ceo_surname_name").val();
				self.continueDataFlow.ceo_job_title = jQuery("#ceo_job_title").val();
				self.continueDataFlow.ceo_business_email = jQuery("#ceo_business_email").val();
				self.continueDataFlow.ceo_business_telephone = jQuery("#ceo_business_telephone").val();
	
				var getIsMaingValue = $('input[name="same_for_main"]:checked').val();
				if(!getIsMaingValue)
				{
					self.continueDataFlow.same_for_main = '';
					self.continueDataFlow.main_contact_given_name = jQuery("#main_contact_given_name").val();
					self.continueDataFlow.main_contact_surname = jQuery("#main_contact_surname").val();
					self.continueDataFlow.main_contact_job_title = jQuery("#main_contact_job_title").val();
					self.continueDataFlow.main_contact_business_email = jQuery("#main_contact_business_email").val();
					self.continueDataFlow.main_contact_business_telephone = jQuery("#main_contact_business_telephone").val();
				}

				if(getcurrentvalue == '2')
				{
					self.continueDataFlow.same_for_billing = 'Yes';
					self.continueDataFlow.billing_main_contact_given_name = '';
					self.continueDataFlow.billing_main_contact_surname = '';
					self.continueDataFlow.billing_main_contact_job_title = '';
					self.continueDataFlow.billing_main_contact_business_email = '';
					self.continueDataFlow.billing_main_contact_business_telephone = '';
				}
				else{
					self.continueDataFlow.same_for_billing = '';
					self.continueDataFlow.billing_main_contact_given_name = '';
					self.continueDataFlow.billing_main_contact_surname = '';
					self.continueDataFlow.billing_main_contact_job_title = '';
					self.continueDataFlow.billing_main_contact_business_email = '';
					self.continueDataFlow.billing_main_contact_business_telephone = '';
				}	

				self.render();
			}
	
		, 	nullCheck: function nullCheck(value) {
				var self = this;
	
				if (value != null && value != '' && value != undefined)
					return false;
				else
					return true;
			}

		,	showModelmessage:function()
			{
				var self = this;
				if(self.IsValidatedUennumber.length > 0)
				{
					self.showConfirmationMessage(self.continueDataFlow.startmessage);
					const getlay1= self.application.layout;		
					var view = new GlobalViewsConfirmationView({
						title: "Alert",
						body: Utils.translate(self.continueDataFlow.startmessage),
						class:'hidden',
						autohide: true,
						parentView: self,

					});


					getlay1.showInModal(view);
				}				
			}	

		, 	nextStepProcess: function (e) {
	
				var self = this;
				if (self.nullCheck(jQuery("#uen").val()) && $('input[name="isoptionentityregisteredwithACRA"]:checked').val() == 'Yes') {
					self.showMessage('UEN number is required', 'error', 'uen');
					return false;
				}
				
				if (self.nullCheck(jQuery("#uen").val()) && $('input[name="isoptionentityregisteredwithACRA"]:checked').val() != 'Yes') {
					self.continueDataFlow.membershipstatus = false;
					self.isnonMember = true;
					self.IsValidatedUennumber = [];
				}
				
				if (self.nullCheck(jQuery("#companyname").val())) {
					self.showMessage('Organisation name is required', 'error', 'companyname');
					return false;
				}
				else if(self.IsValidatedUennumber.length > 0 && self.IsValidatedUennumber[0].memApplStatus.length > 0)
				{
					setTimeout(function() {
						self.showModelmessage();
					}, 300);
				}
				else if(self.isnonMember == false && self.continueDataFlow.membershipstatus == true)
				{
					self.continueDataFlow.uen = jQuery("#uen").val();
					self.continueDataFlow.companyname = self.IsValidatedUennumber.length == 0 ?  jQuery("#companyname").val() : self.continueDataFlow.companyname;
					self.continueDataFlow.isoptionentityregisteredwithACRA = $('input[name="isoptionentityregisteredwithACRA"]:checked').val();
					self.continueDataFlow.isisoptionentityregisteredwithACRA = self.continueDataFlow.isoptionentityregisteredwithACRA == 'Yes';
					self.continueDataFlow.if_the_registered_address_is_same_as_billing_address = self.continueDataFlow.if_the_registered_address_is_same_as_billing_address ? self.continueDataFlow.if_the_registered_address_is_same_as_billing_address : true;
					self.uen_number_saturated_or_non_saturated = false;
					self.address_details_org = true;
					self.fillInformationOrg();
					setTimeout(function() {
						self.showModelmessage();
					}, 300);
					self.render();
				}
				else if(self.isnonMember && self.continueDataFlow.membershipstatus == false)
				{
					self.continueDataFlow.uen = jQuery("#uen").val();
					self.continueDataFlow.companyname = self.IsValidatedUennumber.length == 0 ?  jQuery("#companyname").val() : self.continueDataFlow.companyname;
					self.continueDataFlow.isoptionentityregisteredwithACRA = $('input[name="isoptionentityregisteredwithACRA"]:checked').val();
					self.continueDataFlow.isisoptionentityregisteredwithACRA = self.continueDataFlow.isoptionentityregisteredwithACRA == 'Yes';
					self.continueDataFlow.if_the_registered_address_is_same_as_billing_address = self.continueDataFlow.if_the_registered_address_is_same_as_billing_address ? self.continueDataFlow.if_the_registered_address_is_same_as_billing_address : true;
					self.uen_number_saturated_or_non_saturated = false;
					self.address_details_org = true;
					self.fillInformationOrg();
					self.render();
				}
				else{
					
					setTimeout(function() {
						self.showModelmessage();
					}, 300);
				}
			}

		,	fillInformationOrg : function()
			{
				var self = this;

				if(self.IsValidatedUennumber.length > 0 && self.continueDataFlow.postal_code == undefined)
				{
					var getOrgDetails = self.IsValidatedUennumber[0];
						self.continueDataFlow.postal_code = getOrgDetails.shipzip;
						self.continueDataFlow.street = getOrgDetails.shipaddress1;
						self.continueDataFlow.unit = getOrgDetails.shipaddress2;
						self.continueDataFlow.building = getOrgDetails.shipaddress3;
						self.continueDataFlow.getcountry = getOrgDetails.shipcountry;
						self.continueDataFlow.email = getOrgDetails.email;
						self.continueDataFlow.telephone = getOrgDetails.phone;
						self.continueDataFlow.website = getOrgDetails.sourcesite;
						//self.continueDataFlow.getbusinesssector = getOrgDetails.businesssector;
						self.continueDataFlow.reason_for_joining = getOrgDetails.reasonforjoin;

					if(self.continueDataFlow.if_the_registered_address_is_same_as_billing_address == true && getOrgDetails.billaddress !='')
					{
						self.continueDataFlow.itraisaba_postal_code = getOrgDetails.billzipcode;
						self.continueDataFlow.itraisaba_street = getOrgDetails.billaddress1;
						self.continueDataFlow.itraisaba_unit = getOrgDetails.billaddress2;
						self.continueDataFlow.itraisaba_building = getOrgDetails.billaddress3;
						self.continueDataFlow.itraisaba_getcountry = getOrgDetails.billcountry;
						self.continueDataFlow.if_the_registered_address_is_same_as_billing_address = false;
					}
				}	
			}	

		, 	nextStepProcessbtn: function (e) {
	
			var self = this;
		
			if (self.nullCheck(jQuery("#postal_code").val())) {
				self.showMessage('Postal code is required', 'error', 'postal_code');
				return false;
			}
			else if (self.nullCheck(jQuery("#street").val())) {
				self.showMessage('Block or Street Number is required', 'error', 'street');
				return false;
			}
			else if (self.nullCheck(jQuery("#unit").val())) {
				self.showMessage('Unit Number is required', 'error', 'unit');
				return false;
			}
			else if (self.nullCheck(jQuery("#building").val())) {
				self.showMessage('Building Name is required', 'error', 'building');
				return false;
			}	
			
			// billing address	
			else if (self.nullCheck(jQuery("#itraisaba_postal_code").val()) && self.continueDataFlow.if_the_registered_address_is_same_as_billing_address != true) {
				self.showMessage('Postal code is required', 'error', 'itraisaba_postal_code');
				return false;
			}
			else if (self.nullCheck(jQuery("#itraisaba_street").val()) && self.continueDataFlow.if_the_registered_address_is_same_as_billing_address != true) {
				self.showMessage('Block or Street Number is required', 'error', 'itraisaba_street');
				return false;
			}
			else if (self.nullCheck(jQuery("#itraisaba_unit").val()) && self.continueDataFlow.if_the_registered_address_is_same_as_billing_address != true) {
				self.showMessage('Unit Number is required', 'error', 'itraisaba_unit');
				return false;
			}
			else if (self.nullCheck(jQuery("#itraisaba_building").val()) && self.continueDataFlow.if_the_registered_address_is_same_as_billing_address != true) {
				self.showMessage('Building Name is required', 'error', 'itraisaba_building');
				return false;
			}
			else if (self.nullCheck(jQuery("#email").val()) || !self.validateEmail(jQuery("#email").val())) {
				self.showMessage('General Business email address is required', 'error', 'email');
				return false;
			}
			else if (self.nullCheck(jQuery("#telephone").val())) {
				self.showMessage('General Business telephone is required', 'error', 'telephone');
				return false;
			}
			else if(jQuery("#telephone").val().length < 8)
			{
				self.showMessage('A phone number is required. Please enter at least 8 digits.', 'error', 'telephone');
				return false;
			}
            // else if (jQuery("#website").val() != '' && !self.isValidURL(jQuery("#website").val())) {
			// 	self.showMessage('Company Website is required', 'error', 'website');
			// 	return false;
			// }
			else if (self.nullCheck(jQuery("#website").val())) {
				self.showMessage('Company Website is required', 'error', 'website');
				return false;
			}
			else if (self.nullCheck(jQuery("#hd_business_profile").val()) && self.continueDataFlow.isoptionentityregisteredwithACRA == 'Yes' ) {
				self.showMessage('Document is required', 'error', 'business_profile');
				return false;
			}
			else {
				
				self.assinguploadfilevalue();		
				self.continueDataFlow.street = jQuery("#street").val();
				self.continueDataFlow.postal_code = jQuery("#postal_code").val();
				self.continueDataFlow.getcountry = jQuery("#getcountry").val();
				self.continueDataFlow.email = jQuery("#email").val();
				self.continueDataFlow.telephone = jQuery("#telephone").val();
				self.continueDataFlow.website = jQuery("#website").val();
				self.continueDataFlow.unit = jQuery("#unit").val();
				self.continueDataFlow.building = jQuery("#building").val();
				if(self.continueDataFlow.same_for_main == undefined)
				{
					self.continueDataFlow.same_for_main = '';
				}		

				if(self.continueDataFlow.same_for_billing == undefined)
				{
					self.continueDataFlow.same_for_billing = '';
				}			

				if(self.continueDataFlow.if_the_registered_address_is_same_as_billing_address != true)
				{
					self.continueDataFlow.itraisaba_street = jQuery("#itraisaba_street").val();
					self.continueDataFlow.itraisaba_postal_code = jQuery("#itraisaba_postal_code").val();
					self.continueDataFlow.itraisaba_getcountry = jQuery("#itraisaba_getcountry").val();
					self.continueDataFlow.itraisaba_unit = jQuery("#itraisaba_unit").val();
					self.continueDataFlow.itraisaba_building = jQuery("#itraisaba_building").val();
				}
				else{
					self.continueDataFlow.itraisaba_street = '';
					self.continueDataFlow.itraisaba_postal_code = '';
					self.continueDataFlow.itraisaba_getcountry = '';
					self.continueDataFlow.itraisaba_unit = '';
					self.continueDataFlow.itraisaba_building = '';
				}

				self.uen_number_saturated_or_non_saturated = false;
				self.associate_provide_details = true;
				self.address_details_org = false;
				self.render();
			}
		}
			
		,	assinguploadfilevalue: function(){
				
			var self = this;
			if( self.nullCheck(self.continueDataFlow.hd_business_profile))
			{ 
				self.continueDataFlow.hd_business_profile = jQuery("#hd_business_profile").val();
			}
			else if(jQuery("#business_profile").val().split('\\').pop() != self.continueDataFlow.hd_business_profile.split(',')[2])
			{ 
				self.continueDataFlow.hd_business_profile = jQuery("#hd_business_profile").val();
			}
		}
		, 	nextStepProcessSecond: function (e) {
				var self = this;
				var var_same_for_main = $('input[name="same_for_main"]:checked').val() == "1" ? false : true;
				var var_same_for_billing = $('input[name="same_for_billing"]:checked').val() == "2" ? false : true;
				// Name of Chief Executive Officer/Director (or equivalent)
				if (self.nullCheck(jQuery("#ceo_given_name").val())) {
					self.showMessage('Given name is required', 'error', 'ceo_given_name');
					return false;
				}
				else if (self.nullCheck(jQuery("#ceo_surname_name").val())) {
					self.showMessage('Surname is required', 'error', 'ceo_surname_name');
					return false;
				}
				else if (self.nullCheck(jQuery("#ceo_job_title").val())) {
					self.showMessage('Job title is required', 'error', 'ceo_job_title');
					return false;
				}
				else if (self.nullCheck(jQuery("#ceo_business_email").val()) || !self.validateEmail(jQuery("#ceo_business_email").val())) {
					self.showMessage('Business email address is required', 'error', 'ceo_business_email');
					return false;
				}
				else if (self.nullCheck(jQuery("#ceo_business_telephone").val())) {
					self.showMessage('Business telephone is required', 'error', 'ceo_business_telephone');
					return false;
				}
				else if(jQuery("#ceo_business_telephone").val().length < 8)
				{
					self.showMessage('A phone number is required. Please enter at least 8 digits.', 'error', 'ceo_business_telephone');
					return false;
				}
				// Name For Main Contact person
				else if (self.nullCheck(jQuery("#main_contact_given_name").val()) && var_same_for_main) {
					self.showMessage('Given name is required', 'error', 'main_contact_given_name');
					return false;
				}
				else if (self.nullCheck(jQuery("#main_contact_surname").val()) && var_same_for_main) {
					self.showMessage('Surname is required', 'error', 'main_contact_surname');
					return false;
				}
				else if (self.nullCheck(jQuery("#main_contact_job_title").val()) && var_same_for_main) {
					self.showMessage('Job title is required', 'error', 'main_contact_job_title');
					return false;
				}
				else if ((self.nullCheck(jQuery("#main_contact_business_email").val()) || !self.validateEmail(jQuery("#main_contact_business_email").val())) && var_same_for_main) {
					self.showMessage('Business email address is required', 'error', 'main_contact_business_email');
					return false;
				}
				else if (self.nullCheck(jQuery("#main_contact_business_telephone").val()) && var_same_for_main) {
					self.showMessage('Business telephone is required', 'error', 'main_contact_business_telephone');
					return false;
				}				
				else if(jQuery("#main_contact_business_telephone").val() != undefined && jQuery("#main_contact_business_telephone").val().length < 8 && var_same_for_main)
				{
					self.showMessage('A phone number is required. Please enter at least 8 digits.', 'error', 'main_contact_business_telephone');
					return false;
				}
				// Name For Billing Contact Person
				else if (self.nullCheck(jQuery("#billing_main_contact_given_name").val()) && var_same_for_billing) {
					self.showMessage('Given name is required', 'error', 'billing_main_contact_given_name');
					return false;
				}
				else if (self.nullCheck(jQuery("#billing_main_contact_surname").val()) && var_same_for_billing) {
					self.showMessage('Surname is required', 'error', 'billing_main_contact_surname');
					return false;
				}
				else if (self.nullCheck(jQuery("#billing_main_contact_job_title").val()) && var_same_for_billing) {
					self.showMessage('Job title is required', 'error', 'billing_main_contact_job_title');
					return false;
				}
				else if ((self.nullCheck(jQuery("#billing_main_contact_business_email").val()) || !self.validateEmail(jQuery("#billing_main_contact_business_email").val())) && var_same_for_billing) {
					self.showMessage('Business email address is required', 'error', 'billing_main_contact_business_email');
					return false;
				}
				else if (self.nullCheck(jQuery("#billing_main_contact_business_telephone").val()) && var_same_for_billing) {
					self.showMessage('Business telephone is required', 'error', 'billing_main_contact_business_telephone');
					return false;
				}
				else if(jQuery("#billing_main_contact_business_telephone").val() != undefined && jQuery("#billing_main_contact_business_telephone").val().length < 8 && var_same_for_billing)
				{
					self.showMessage('A phone number is required. Please enter at least 8 digits.', 'error', 'billing_main_contact_business_telephone');
					return false;
				}		
				else {
					self.continueDataFlow.ceo_given_name = jQuery("#ceo_given_name").val();
					self.continueDataFlow.ceo_surname_name = jQuery("#ceo_surname_name").val();
					self.continueDataFlow.ceo_job_title = jQuery("#ceo_job_title").val();
					self.continueDataFlow.ceo_business_email = jQuery("#ceo_business_email").val();
					self.continueDataFlow.ceo_business_telephone = jQuery("#ceo_business_telephone").val();
					self.continueDataFlow.same_for_main = $('input[name="same_for_main"]:checked').val() == "1" ? 'Yes' : '';
					self.continueDataFlow.same_for_billing = $('input[name="same_for_billing"]:checked').val() == "2" ? 'Yes' : '';
					// self.continueDataFlow.details_of_business = $('input[name="details_of_business"]:checked').val();
					// self.continueDataFlow.details_of_marketing = $('input[name="details_of_marketing"]:checked').val();
					// Name For Main Contact person
					self.continueDataFlow.main_contact_given_name = jQuery("#main_contact_given_name").val();
					self.continueDataFlow.main_contact_surname = jQuery("#main_contact_surname").val();
					self.continueDataFlow.main_contact_job_title = jQuery("#main_contact_job_title").val();
					self.continueDataFlow.main_contact_business_email = jQuery("#main_contact_business_email").val();
					self.continueDataFlow.main_contact_business_telephone = jQuery("#main_contact_business_telephone").val();
	
					// Name For Billing Contact Person
					self.continueDataFlow.billing_main_contact_given_name = jQuery("#billing_main_contact_given_name").val();
					self.continueDataFlow.billing_main_contact_surname = jQuery("#billing_main_contact_surname").val();
					self.continueDataFlow.billing_main_contact_job_title = jQuery("#billing_main_contact_job_title").val();
					self.continueDataFlow.billing_main_contact_business_email = jQuery("#billing_main_contact_business_email").val();
					self.continueDataFlow.billing_main_contact_business_telephone = jQuery("#billing_main_contact_business_telephone").val();
					self.continueDataFlow.globalcontactlist = self.globaladdresslist;
					self.continueDataFlow.folderlocfile = SC.CONFIGURATION.AssoMembForm.config;

					self.uen_number_saturated_or_non_saturated = false;
					self.associate_provide_details = false;
					self.address_details_org = false;
					self.associate_provide_details_another = true;
					//self.listbusinesssector = self.getBusinessSectorList();

					self.continueDataFlow.option_referred_by_member_yes_No = self.continueDataFlow.option_referred_by_member_yes_No == 'Yes' ? 'Yes' : 'No';
					self.continueDataFlow.option_referred_by_member_yes = self.continueDataFlow.option_referred_by_member_yes == true ? true : false;
					self.continueDataFlow.option_referred_by_member_no = self.continueDataFlow.option_referred_by_member_yes == true ? false : true;

					self.render();
				}
			}
			
		, 	nextStepProcessBack_1: function (e) {
			var self = this;
				self.uen_number_saturated_or_non_saturated = true;
				self.address_details_org = false;
				self.render();
		}
	
		, nextStepProcessBack: function (e) {
			var self = this;
				self.uen_number_saturated_or_non_saturated = false;
				self.address_details_org = true;
				self.associate_provide_details = false;
				self.render();
		}
	
		, 	nextStepProcessSecondBack: function (e) {
			var self = this;

				self.continueDataFlow.getbusinesssector = ""; //jQuery("#getbusinesssector").val();
				self.continueDataFlow.getbusinesssector_text = ""; //jQuery("#getbusinesssector option:selected").text();
				self.continueDataFlow.nature_of_business = jQuery("#nature_of_business").val();
				self.continueDataFlow.annual_turnover = jQuery("#annual_turnover").val();
				self.continueDataFlow.fixed_assets_investments = jQuery("#fixed_assets_investments").val();
				self.continueDataFlow.total_employees = jQuery("#total_employees").val();
				self.continueDataFlow.reason_for_joining = jQuery("#reason_for_joining").val();
				self.continueDataFlow.howdidiyoujknowsbf = jQuery("#howdidiyoujknowsbf").val();
				self.continueDataFlow.howdidiyoujknowsbf_text = jQuery("#howdidiyoujknowsbf option:selected").text();
				self.continueDataFlow.details_event_other = jQuery("#details_event_other").val();
				self.continueDataFlow.option_referred_by_member_yes_No = $('input[name="option_referred_by_member"]:checked').val();
				self.continueDataFlow.referral_name = jQuery("#referral_name").val();
				self.continueDataFlow.referral_department = jQuery("#referral_department").val();
				self.continueDataFlow.referral_company = jQuery("#referral_company").val();
				self.continueDataFlow.Interestineventcollaborationandpartnershipppportunities = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val();

				var aoi_chk_arr =  jQuery('input[name="areas_of_interest[]"]:checked');
				var aoi_chklength = aoi_chk_arr.length;             
				var aoi_array = []
				for(var aoi=0; aoi < aoi_chklength;aoi++)
				{
					aoi_array.push(aoi_chk_arr[aoi].value)
				} 
				self.continueDataFlow.areas_of_interest = aoi_array;

				self.uen_number_saturated_or_non_saturated = false;
				self.associate_provide_details = true;
				self.address_details_org = false;
				self.associate_provide_details_another = false;
				self.render();
		}
	
		, 	nextStepProcessThird: function (e) {
	
				var self = this;
				var var_option_referred_by_member = $('input[name="option_referred_by_member"]:checked').val();
				var numberRegex = /^\s*[+-]?(\d+|\d*\.\d+|\d+\.\d*)([Ee][+-]?\d+)?\s*$/
				
				// if (self.nullCheck(jQuery("#getbusinesssector").val())) {
				// 	self.showMessage('Please select business sector type', 'error', 'getbusinesssector');
				// 	return false;
				// }
				if (self.nullCheck(jQuery("#nature_of_business").val())) {
					self.showMessage('Field is required', 'error', 'nature_of_business');
					return false;
				}
				else if (!self.nullCheck(jQuery("#annual_turnover").val()) && !numberRegex.test(jQuery("#annual_turnover").val())) {
					self.showMessage('Invalid numeric field value', 'error', 'annual_turnover');
					return false;
				}
				else if (!self.nullCheck(jQuery("#fixed_assets_investments").val()) && !numberRegex.test(jQuery("#fixed_assets_investments").val())) {
					self.showMessage('Invalid numeric field value', 'error', 'fixed_assets_investments');
					return false;
				}
				else if (self.nullCheck(jQuery("#total_employees").val())) {
				 	self.showMessage('Field is required', 'error', 'total_employees');
				 	return false;
				}
				else if (self.nullCheck(jQuery("#reason_for_joining").val())) {
					self.showMessage('Field is required', 'error', 'reason_for_joining');
					return false;
				}
				else if ((jQuery('input[name="areas_of_interest[]"]:checked').length > 3) || (jQuery('input[name="areas_of_interest[]"]:checked').length) == 0) {
					self.showMessage('Please select only up to three areas if interest.', 'error', 'areas_of_interest');
					return false;
				}
				else if (self.nullCheck(jQuery("#referral_name").val()) && var_option_referred_by_member =='Yes') {
					self.showMessage('Field is required', 'error', 'referral_name');
					return false;
				}
				else if (self.nullCheck(jQuery("#referral_department").val()) && var_option_referred_by_member =='Yes') {
					self.showMessage('Field is required', 'error', 'referral_department');
					return false;
				}
				else if (self.nullCheck(jQuery("#referral_company").val()) && var_option_referred_by_member == 'Yes' ) {
					self.showMessage('Field is required', 'error', 'referral_company');
					return false;
				}
				else if (self.nullCheck(jQuery("#howdidiyoujknowsbf").val())) {
					self.showMessage('Field is required', 'error', 'howdidiyoujknowsbf');
					return false;
				}
				else if ((jQuery("#howdidiyoujknowsbf").val() ==3 || jQuery("#howdidiyoujknowsbf").val() == 4) && self.nullCheck(jQuery("#details_event_other").val()) ) {
					self.showMessage('Field is required', 'error', 'details_event_other');
					return false;
				}
				else if ((jQuery("#howdidiyoujknowsbf").val() == 5) && self.nullCheck(jQuery("#details_event_other").val()) ) {
					self.showMessage('Field is required', 'error', 'details_event_other');
					return false;
				}
				else {
					self.continueDataFlow.getbusinesssector = ""; //jQuery("#getbusinesssector").val();
					self.continueDataFlow.getbusinesssector_text = ""; //jQuery("#getbusinesssector option:selected").text();
					self.continueDataFlow.nature_of_business = jQuery("#nature_of_business").val();
					self.continueDataFlow.annual_turnover = jQuery("#annual_turnover").val();
					self.continueDataFlow.fixed_assets_investments = jQuery("#fixed_assets_investments").val();
					self.continueDataFlow.total_employees = jQuery("#total_employees").val();
					self.continueDataFlow.reason_for_joining = jQuery("#reason_for_joining").val();
					self.continueDataFlow.howdidiyoujknowsbf = jQuery("#howdidiyoujknowsbf").val();
					self.continueDataFlow.howdidiyoujknowsbf_text = jQuery("#howdidiyoujknowsbf option:selected").text();
					self.continueDataFlow.details_event_other = jQuery("#details_event_other").val();
					self.continueDataFlow.option_referred_by_member_yes_No = $('input[name="option_referred_by_member"]:checked').val();
					self.continueDataFlow.referral_name = jQuery("#referral_name").val();
					self.continueDataFlow.referral_department = jQuery("#referral_department").val();
					self.continueDataFlow.referral_company = jQuery("#referral_company").val();
					self.continueDataFlow.Interestineventcollaborationandpartnershipppportunities = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val() == 'on' ? 'Yes' : 'No'; 
					self.continueDataFlow.ievent_coll_part_oppr = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val() == 'on' ? true : false; 

					var aoi_chk_arr =  jQuery('input[name="areas_of_interest[]"]:checked');
					var aoi_chklength = aoi_chk_arr.length;             
					var aoi_array = []
					var aoi_array_label = []
					for(var aoi=0; aoi < aoi_chklength;aoi++)
					{
						aoi_array.push(aoi_chk_arr[aoi].value)
						aoi_array_label.push(jQuery(':checkbox[id='+aoi_chk_arr[aoi].id+']').next('label').text());
					} 
					self.continueDataFlow.areas_of_interest = aoi_array;
					self.continueDataFlow.areas_of_interest_label = aoi_array_label;
					self.uen_number_saturated_or_non_saturated = false;
					self.associate_provide_details = false;
					self.associate_provide_details_another = false;
					self.associate_provide_details_review_submited = true;
					self.render();
				}
			}
	
		
		, 	nextStepProcessThirdBack: function (e) {
				var self = this;
					self.uen_number_saturated_or_non_saturated = false;
					self.associate_provide_details = false;
					self.address_details_org = false;
					self.associate_provide_details_another = true;
					self.associate_provide_details_review_submited = false;

					self.continueDataFlow.submitting_person_option = jQuery("#submitting_person_option").val();
					self.continueDataFlow.designation_option = jQuery("#designation_option").val();
					self.continueDataFlow.business_email_option = jQuery("#business_email_option").val();
					self.continueDataFlow.details_of_business_option = $('input[name="details_of_business_option"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcomekit_check = 'Yes'; //$('input[name="welcomekit"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcome_kit_name = jQuery("#welcome_kit_name").val();
					self.continueDataFlow.welcome_kit_jobtitle = jQuery("#welcome_kit_jobtitle").val();
					self.continueDataFlow.welcomekit_email = jQuery("#welcome_kit_email").val();
					//self.continueDataFlow.Interestineventcollaborationandpartnershipppportunities = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val() == 'on' ? 'Yes' : '';
					//self.continueDataFlow.ievent_coll_part_oppr = $('input[name="Interestineventcollaborationandpartnershipppportunities"]:checked').val() == 'on' ? true : false; 
					self.continueDataFlow.email_option_submited = '';
					
					self.render();
			}
	
		, saveTheForm: function (e, model, props) {
				e.preventDefault();
				var self = this;
				if (self.nullCheck(jQuery("#submitting_person_option").val())) {
						self.showMessage('Field is required', 'error', 'submitting_person_option');
						return false;
				}
				else if (self.nullCheck(jQuery("#designation_option").val())) {
					self.showMessage('Field is required', 'error', 'designation_option');
					return false;
				}
				else if (self.nullCheck(jQuery("#business_email_option").val()) || !self.validateEmail(jQuery("#business_email_option").val())) {
					self.showMessage('Business email address is required', 'error', 'business_email_option');
					return false;
				}
				// else if (self.nullCheck(jQuery("#email_option_submited").val()) || !self.validateEmail(jQuery("#email_option_submited").val())) {
				// 	self.showMessage('email address is required', 'error', 'email_option_submited');
				// 	return false;
				// }
				else if ($('input[name="welcomekit"]:checked').val() == "on" && self.nullCheck(jQuery("#welcome_kit_name").val())) {
					self.showMessage('Name is required', 'error', 'welcome_kit_name');
					return false;
				}
				else if ($('input[name="welcomekit"]:checked').val() == "on" && self.nullCheck(jQuery("#welcome_kit_jobtitle").val())) {
					self.showMessage('Job Title is required', 'error', 'welcome_kit_jobtitle');
					return false;
				}
				else if ($('input[name="welcomekit"]:checked').val() == "on" && !self.validateEmail(jQuery("#welcome_kit_email").val())) {
					self.showMessage('Email address is required', 'error', 'welcome_kit_email');
					return false;
				}
				else if (self.nullCheck($('input[name="details_of_business_option"]:checked').val())) {
					self.showMessage('You must accept the terms and conditions.', 'error', 'details_of_business_option');
					return false;
				}
				else {
				
					self.continueDataFlow.submitting_person_option = jQuery("#submitting_person_option").val();
					self.continueDataFlow.designation_option = jQuery("#designation_option").val();
					self.continueDataFlow.business_email_option = jQuery("#business_email_option").val();
					self.continueDataFlow.details_of_business_option = $('input[name="details_of_business_option"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcomekit_check = 'Yes'; //$('input[name="welcomekit"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcome_kit_name = jQuery("#welcome_kit_name").val();
					self.continueDataFlow.welcome_kit_jobtitle = jQuery("#welcome_kit_jobtitle").val();
					self.continueDataFlow.welcomekit_email = jQuery("#welcome_kit_email").val();
					
					if(window.location.href.split("?").length > 1)
					{
						self.continueDataFlow.track_referral_link = window.location.href.split("?")[1];
					}
					else{
						self.continueDataFlow.track_referral_link = '';
					}

					self.continueDataFlow.email_option_submited = '';// jQuery("#email_option_submited").val();
					this.model.set(self.continueDataFlow);
					e.data = self.continueDataFlow;
					var promise = BackboneFormView.saveForm.call(this, e, this.model, self.continueDataFlow)
						return promise && promise.then
						(
							function (responce) {
								if (responce.successMessage) {
									self.showMessage(responce.successMessage, 'success');
									self.IsValidatedUennumber = [];
									self.uen_number_saturated_or_non_saturated = false;
									self.associate_provide_details = false;
									self.address_details_org = false;
									self.associate_provide_details_another = false;
									self.associate_provide_details_review_submited = false;
									self.show_message_submited = true;
									self.show_number = responce.id;
									self.comemailid = responce.comemailid;
									self.associate_provide_details_review_showed = '';
									self.continueDataFlow = {};
									self.render();
								}
								else {
									self.showMessage(responce.errorMessage, 'error')
								}
	
								return false;
							}
						);
				}
			}
	
		,	ppdotf:function(e)
			{
				var self=this;
				self.continueDataFlow.ceo_given_name = jQuery("#ceo_given_name").val();
				self.continueDataFlow.ceo_surname_name = jQuery("#ceo_surname_name").val();
				self.continueDataFlow.ceo_job_title = jQuery("#ceo_job_title").val();
				self.continueDataFlow.ceo_business_email = jQuery("#ceo_business_email").val();
				self.continueDataFlow.ceo_business_telephone = jQuery("#ceo_business_telephone").val();
				self.continueDataFlow.same_for_main = $('input[name="same_for_main"]:checked').val() == "1" ? 'Yes' : '';
				self.continueDataFlow.same_for_billing = $('input[name="same_for_billing"]:checked').val() == "2" ? 'Yes' : '';
				// self.continueDataFlow.details_of_business = $('input[name="details_of_business"]:checked').val();
				// self.continueDataFlow.details_of_marketing = $('input[name="details_of_marketing"]:checked').val();
				// Name For Main Contact person
				self.continueDataFlow.main_contact_given_name = jQuery("#main_contact_given_name").val();
				self.continueDataFlow.main_contact_surname = jQuery("#main_contact_surname").val();
				self.continueDataFlow.main_contact_job_title = jQuery("#main_contact_job_title").val();
				self.continueDataFlow.main_contact_business_email = jQuery("#main_contact_business_email").val();
				self.continueDataFlow.main_contact_business_telephone = jQuery("#main_contact_business_telephone").val();

				// Name For Billing Contact Person
				self.continueDataFlow.billing_main_contact_given_name = jQuery("#billing_main_contact_given_name").val();
				self.continueDataFlow.billing_main_contact_surname = jQuery("#billing_main_contact_surname").val();
				self.continueDataFlow.billing_main_contact_job_title = jQuery("#billing_main_contact_job_title").val();
				self.continueDataFlow.billing_main_contact_business_email = jQuery("#billing_main_contact_business_email").val();
				self.continueDataFlow.billing_main_contact_business_telephone = jQuery("#billing_main_contact_business_telephone").val();

				self.continueDataFlow.option_referred_by_member_yes_No = 'No';
				self.continueDataFlow.option_referred_by_member_yes = false;
				self.continueDataFlow.option_referred_by_member_no = true;
			}

		, 	dynemicAddressCall: function (e)
			{
				e.preventDefault();
				var self=this;
				var model = new AssoMembFormSS2Model();
				var application = this.application;
				var Layout = application.getLayout();
			  	var id= jQuery(e.target).data('id');	
				var _ppdotf = self.ppdotf();
				var view = new GlobalformAddressView({
					application: application,
					model: model,
					profile:self.data || '',
					globaladdresslist:self.globaladdresslist,
					globaladdresslistselected:[],
					id:""
			  	});				
			  	
				Layout.showInModal(view);
				view.model.on('reset sync remove change destroy', function (model) {     
					self.render(); 					
				});
			}

		, 	dynemicAddressCallUpdate: function (e)
			{
				e.preventDefault();
				var self=this;
				var model = new AssoMembFormSS2Model();
				var application = this.application;
				var Layout = application.getLayout();
			  	var id=  jQuery(e.target).val();
     			var _ppdotf = self.ppdotf();

				if(id)
				{
					var view = new GlobalformAddressView({
						application: application,
						model: model,
						profile:self.data || '',
						globaladdresslist:self.globaladdresslist,
						globaladdresslistselected:self.globaladdresslist.filter(function(addr){  if(addr.global_business_email == id) {return addr;}}),
						id:id
					  });				
					  
					Layout.showInModal(view);
					view.model.on('reset sync remove change destroy', function (model) {     
						self.render(); 					
					});
				}			
			}

		,	dynemicAddressCallsRemove : function(e)
			{
				e.preventDefault();
				var self=this;
			  	var id=  jQuery(e.target).val();
				if(id)
				{
					var selectedAddrRemove = self.globaladdresslist.filter(function(addr){  if(addr.global_business_email != id) {return addr;}});
					self.globaladdresslist = selectedAddrRemove;
					var _ppdotf = self.ppdotf();
					self.render(); 					
				}		
			}

		,	isReviewsubmission : function(e)
			{			
				e.preventDefault();
				var self = this;
					self.continueDataFlow.submitting_person_option = jQuery("#submitting_person_option").val();
					self.continueDataFlow.designation_option = jQuery("#designation_option").val();
					self.continueDataFlow.business_email_option = jQuery("#business_email_option").val();
					self.continueDataFlow.details_of_business_option = $('input[name="details_of_business_option"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcomekit_check = 'Yes'; //$('input[name="welcomekit"]:checked').val() == 'on' ? 'Yes' : '';
					self.continueDataFlow.welcome_kit_name = jQuery("#welcome_kit_name").val();
					self.continueDataFlow.welcome_kit_jobtitle = jQuery("#welcome_kit_jobtitle").val();
					self.continueDataFlow.welcomekit_email = jQuery("#welcome_kit_email").val();
					self.continueDataFlow.email_option_submited = '';// jQuery("#email_option_submited").val();
				if (this.options.container.layout) {				
					var modalMessage = new ReviewSubmissionView({ container: this.options.container,continueDataFlow: self.continueDataFlow,title:'Form Summary'});
						modalMessage.modalClass ='modal-md';
						modalMessage.title = 'Form Summary';
						this.options.container.layout.showInModal(modalMessage);
					return false;
				}			
			}
	
		, 	showMessage: function (message, type, field) {
				jQuery('.global-views-message-error').remove();
				jQuery('.global-views-message-success').remove();
	
				var messageView = new MessageView
					({
						message: message
						, type: type
						, closable: type == 'error' ? true : false
					});
				if (typeof field !== 'undefined') {
					this.options.application.getLayout().$('[data-input="' + field + '"]').append(messageView.render().$el);
				}
				else if (type == 'error') {
					this.options.application.getLayout().$('form').append(messageView.render().$el);
				}
				else {
					this.options.application.getLayout().$('form').append(messageView.render().$el);
				}
			}
	
		, 	validateEmail: function (email) {
	
				var self = this;
				var re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
				return re.test(email);
			}
	
	
		,	getBusinessSectorList: function () {
	
				var self = this;
				this.models = new AssoMembFormSS2Model();
					self.listbusinesssector = []
	
					this.models.fetch({async: false,data: {
					   'getmethod':'getbusinesssectorlist'
					   }}).done(function(result) {
						if(result)
						{
							self.listbusinesssector = result;
						}				 
					});
	
				return self.listbusinesssector
			}
	
		, 	IsValidatedUen: function (e) {
				//e.preventDefault();
				var self = this;
					self.continueDataFlow = {};
					self.continueDataFlow.companynameId = '';
				var getcurrentvalue = jQuery('#uen').val().trim();
				//if (getcurrentvalue) {
					var AssoMembFormModel = new AssoMembFormSS2Model();
						AssoMembFormModel.fetch({
						data: {
							'uen_no': getcurrentvalue,
							'method': 'checkUENnumberIsValid'
						}
					}).done(function (response) {
	
						if (response.length === 0) {
							self.continueDataFlow.membershipstatus = false;
							self.isnonMember = true;
							self.IsValidatedUennumber = [];
							//self.showMessage('The UEN you entered was not found in our records.Please contact to associatemember@sbf.org.sg for further clarrification', 'error', 'uen');
						}
						else {
							jQuery('.global-views-message-error').remove();
							for (var n = 0; n < response.length; n++) {
								self.IsValidatedUennumber = response;
								self.continueDataFlow.companynameId = response[0].internalid;
								self.continueDataFlow.companyname = response[0].name;
								self.continueDataFlow.membershipstatus = response[0].membershipstatus;
								self.isnonMember =  response[0].isvalidSaturityMember;

								if(response[0].membershipstatus == true)
								{
									self.continueDataFlow.startmessage = "The provided UEN already exists and is associated with a '"+response[0].membershipstatus_text+"' status. To reapply, please note that an additional entrance fee may be required alongside the subscription fee. For more information on your membership status or to resolve this issue, please email us at associatemember@sbf.org.sg or contact us at 6827 6844.";
								}
								else if(response[0].membershiptype_text =='Statutory Member')
								{
									self.continueDataFlow.startmessage = "The provided UEN is already registered under Statutory Membership. As a result, you cannot proceed with this application. For clarification on your membership status or further assistance, please email us at associatemember@sbf.org.sg or contact us at 6827 6844.";
								}
								else if(response[0].memApplStatus.length > 0)
								{
									self.continueDataFlow.startmessage = "Your ongoing application with the provided UEN is under review. Please wait until the review process is complete. Your last reference number is "+ response[0].memApplStatus[0].membshipname +". For assistance, email associatemember@sbf.org.sg or call 6827 6844.";
									//self.continueDataFlow.startmessage = "Application already under processing, please try after sometime,your last refernce number is <a href=\"https://www.google.com/\" target=\"_blank\">"+response[0].memApplStatus[0].membshipname+"</a> " ;
								}
								else{
									//self.continueDataFlow.startmessage = "UEN number already exits and "+ response[0].membershiptype_text;
									self.continueDataFlow.startmessage = "The provided UEN is already registered under "+response[0].membershiptype_text+". As a result, you cannot proceed with this application. For clarification on your membership status or further assistance, please email us at associatemember@sbf.org.sg or contact us at 6827 6844.";
								}
								
								jQuery("#companyname").val(response[0].name);
							}
						}
					});
				//}
			}
	
			//@method getContext @return NVT.AssociateMembershipForm.AssoMembForm.View.Context
		,	getContext: function getContext()
			{
				var self = this;
	
				return {
	
					uen_number_saturated_or_non_saturated : self.uen_number_saturated_or_non_saturated,
	
					address_details_org : self.address_details_org ,
	
					associate_provide_details : self.associate_provide_details ,
	
					associate_provide_details_another : self.associate_provide_details_another ,
	
					associate_provide_details_review_submited : self.associate_provide_details_review_submited ,
	
					show_message_submited : self.show_message_submited ,

					show_number : self.show_number || '',

					comemailid : self.comemailid || '',
	
					associate_provide_details_review_showed : self.associate_provide_details_review_showed ,
	
					continueDataFlow : self.continueDataFlow || '',

					yes_entityregisteredwithACRA : self.continueDataFlow.isisoptionentityregisteredwithACRA == undefined ?  true : self.continueDataFlow.isisoptionentityregisteredwithACRA === true,

					yes_withoutentityregisteredwithACRA : self.continueDataFlow.isisoptionentityregisteredwithACRA == undefined ?  false : self.continueDataFlow .isisoptionentityregisteredwithACRA  !== true,
	
					listbusinesssector : self.listbusinesssector || [],

					bindglobaladdresslist : self.globaladdresslist || [],

					dynamictablethead1 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictablethead1 || '',
					dynamictablethead2 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictablethead2 || '',
					dynamictablethead3 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictablethead3 || '',
					dynamictabletd1 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd1 || '',
					dynamictabletd2 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd2 || '',
					dynamictabletd3 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd3 || '',
					dynamictabletd4 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd4 || '',
					dynamictabletd5 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd5 || '',
					dynamictabletd6 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd6 || '',
					dynamictabletd7 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd7 || '',
					dynamictabletd8 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd8 || '',
					dynamictabletd9 :  SC.CONFIGURATION.AssoMembFormsubtab.dynamictabletd9 || '',
					entrancefeenote1 :  SC.CONFIGURATION.AssoMembFormsubtab.entrancefeenote1 || '',
					entrancefeenote2 :  SC.CONFIGURATION.AssoMembFormsubtab.entrancefeenote2 || '',
					entrancefeenote3 :  SC.CONFIGURATION.AssoMembFormsubtab.entrancefeenote3 || '',
					entrancefeenote4 :  SC.CONFIGURATION.AssoMembFormsubtab.entrancefeenote4 || '',	
				};
			}
		});
	});
	
